<div class="carousel-wrapper">
  <div class="carousel-title" [ngClass]="{'open': open}">
    <h5 (click)="open = !open">{{language.SIMILARES_TITLE}}</h5>
  </div>
  <div class="carousel" [ngClass]="{'open': open}">
    <div
    *ngIf="canGoLeft"
    (click)="goLeft()"
    class="carousel-control carousel-control-left">
  </div>
    <div
     *ngIf="canGoRight"
     (click)="goRight()"
     class="carousel-control carousel-control-right">
    </div>
    <div class="carousel-imgs" DragScroll>
      <div class="carousel-imgs-container">
        <div class="carousel-img" *ngFor="let item of items" (click)="applyFilter(item)">
          <div class="img-container" [style.background-image]="'url('+ item.IMAGENMINIURL + ')'">
          </div>
          <div class="img-title">
            {{item.NOMBRE}}
          </div>
        </div>
        <h4 *ngIf="!items.length">{{language.NO_RESULTS_TITLE}}</h4>
      </div>
    </div>
  </div>
</div>
